exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cap-progress-showcase{width:150px}.ant-progress.cap-progress-v2 .ant-progress-circle-path{stroke:#8517e5 !important}.ant-progress.cap-progress-v2 .ant-progress-bg{background-color:#8517e5}\n", ""]);

// exports
